<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "app",
  computed: {
    ...mapGetters(["users"]),
    nextRoute() {
      //redirects to the place it was intending to go before login in
      return this.$route.query.redirect || "/";
    }
  },
  watch: {
    /*user(auth) {
      if (auth) {
        this.$router.replace(this.nextRoute);
      }
    },*/
    $route(to, from) {
      const query = Object.assign({}, to.query);
      this.$store.commit("SETUP_URL_SETTINGS", query);
    }
  }
};
</script>
